import { TurboMount } from "turbo-mount";
import React from "react";
import { registerComponent } from "turbo-mount/react";

// i18n
import { IntlProvider } from "react-intl";
import fr from "../../config/locales/js-lang/fr.json";
import en from "../../config/locales/js-lang/en.json"; // on mettra le compile plus tard

// Composants React
import SoundSelect from './components/SoundSelect'
import PostStateManager from './components/Publisher/PostStateManager'
import ProfilePictureEditor from './components/ProfilePictureEditor'
import PostFormController from './controllers/post_form_controller'
import ContentFormController from './controllers/content_form_controller'
import CCForm from './components/CCForm'

const turboMount = new TurboMount();

// to register a component use:
// registerComponent(turboMount, "Hello", Hello); // where Hello is the imported the component

// to override the default controller use:
// registerComponent(turboMount, "Hello", Hello, HelloController); // where HelloController is a Stimulus controller extended from TurboMountController

// If you want to automatically register components use:
// import { registerComponents } from "turbo-mount/registerComponents/react";
// const controllers = import.meta.glob("/controllers/**/*_controller.js", { eager: true });
// const components = import.meta.glob("/components/**/*.jsx", { eager: true });
// registerComponents({ turboMount, components, controllers });


// On wrap nos composants dans un HOC provider du context de traduction
const messages = { fr, en };

const translate = (component) => (props) => React.createElement(
	IntlProvider,
	{ locale: props.locale || "fr", messages: messages[props.locale] || fr },
	React.createElement(component, props)
)


registerComponent(turboMount, "SoundSelect", translate(SoundSelect));
registerComponent(turboMount, "PostStateManager", translate(PostStateManager), PostFormController);
registerComponent(turboMount, "ProfilePictureEditor", translate(ProfilePictureEditor));
registerComponent(turboMount, "ContentForm", translate(CCForm), ContentFormController);
// TODO: passer les autres composants 

/* <div class="w-2/3 p-2 mx-auto">
<!-- Form Fields -->
<%= form_with model: sequence, local: true do |f| %>
  <%= f.label :title, "Title" %>
  <%= f.text_field :title, class: "block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm" %>
  <%= f.label :text, "Text" %>
  <%= f.text_area :text, class: "block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm" %>
<% end %>
</div>


<div class="w-2/3 p-2 mx-auto">
<!-- Form Fields -->
<%= form_with model: sequence, local: true do |f| %>
  <%= f.label :title, "Title" %>
  <%= f.text_field :title, class: "block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm" %>
  <%= f.label :text, "Text" %>
  <%= f.text_area :text, class: "block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm" %>
<% end %>
</div> */

